module.exports = __webpack_public_path__ + "static/img/product_images_13_h5_zh.5bef461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_13_h5_zh.png
// module id = +ztD
// module chunks = 34